import { Dispatch } from 'react-redux';
import l10n from '@built/i18n';

export const SIGNAL_LANGUAGE_READY = 'SIGNAL_LANGUAGE_READY';
export const INITIALIZE_LANGUAGE = 'INITIALIZE_LANGUAGE';

export const signalLanguageReady = () => ({ type: SIGNAL_LANGUAGE_READY });
export const initializeLanguage = () => ({ type: INITIALIZE_LANGUAGE });

export interface SignalLanguageReady {
  type: typeof SIGNAL_LANGUAGE_READY;
}

export interface InitializeLanguage {
  type: typeof INITIALIZE_LANGUAGE;
}

export type LanguageAction = SignalLanguageReady | InitializeLanguage;

export const initializeI18n = (
  i18n: typeof l10n,
  dispatch: Dispatch<LanguageAction>
) => {
  dispatch(initializeLanguage());
  i18n.on('initialized', () => {
    // Force en-US in production untill translations are ready
    if (window.location.hostname === 'id.getbuilt.com') {
      i18n.changeLanguage('en-US', () => {
        dispatch(signalLanguageReady());
      });
    } else {
      dispatch(signalLanguageReady());
    }
  });
};



// WEBPACK FOOTER //
// ./src/actions/i18n.ts